import React from 'react';
import { getVideoUrl } from '../config/cdn';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faCalendar, faPhone } from '@fortawesome/free-solid-svg-icons';

const Experiencias = () => {

  return (
    <div className="min-h-screen bg-white">
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <video 
          autoPlay 
          muted 
          loop 
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={getVideoUrl("Cenas de negocios hero.mp4")} type="video/mp4" />
        </video>
        
        <div className="absolute inset-0 bg-black/40" />
        
        <div className="relative z-10 text-center text-white px-6 max-w-4xl mx-auto">
          <h1 className="font-sans text-5xl md:text-7xl font-light leading-tight mb-6">
            Vive la <span className="text-green-400 font-normal italic">Experiencia</span>
          </h1>
          <p className="font-sans text-xl md:text-2xl leading-relaxed opacity-90">
            Cada momento en ADASTRA es una historia por contar. 
            Descubre los sabores, sonidos y emociones que hacen única cada visita.
          </p>
        </div>
      </section>

      
      {/* Sección 1: Coctelería Artesanal - 3 divisiones */}
      <section className="grid grid-cols-1 md:grid-cols-3 min-h-[60vh]">
        <div className="relative flex items-end justify-center p-8 overflow-hidden">
          <video 
            autoPlay 
            muted 
            loop 
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={getVideoUrl("Coctelria Super.mp4")} type="video/mp4" />
          </video>
          
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative z-10 text-center">
            <h3 className="font-sans text-2xl md:text-3xl font-light text-white mb-2">
              Mixología Premium
            </h3>
            <p className="font-sans text-sm text-gray-200">Arte líquido en cada creación</p>
          </div>
        </div>
        <div className="relative flex items-end justify-center p-8 overflow-hidden">
          <video 
            autoPlay 
            muted 
            loop 
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src="https://customer-assets.emergentagent.com/job_adastra-resto-1/artifacts/jk6t9utn_Barra%20con%20bartender%20haciendo%20Mijita%20.mp4" type="video/mp4" />
          </video>
          
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative z-10 text-center">
            <h3 className="font-sans text-2xl md:text-3xl font-light text-white mb-2">
              Técnicas Artesanales
            </h3>
            <p className="font-sans text-sm text-gray-200">Maestros bartenders en acción</p>
          </div>
        </div>
        <div className="relative flex items-end justify-center p-8 overflow-hidden">
          <video 
            autoPlay 
            muted 
            loop 
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={getVideoUrl("trago de reversa sin logo .mp4")} type="video/mp4" />
          </video>
          
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative z-10 text-center">
            <h3 className="font-sans text-2xl md:text-3xl font-light text-white mb-2">
              Signature Cocktails
            </h3>
            <p className="font-sans text-sm text-gray-200">Sabores únicos de ADASTRA</p>
          </div>
        </div>
      </section>

      {/* Sección 2: Cena Romántica - 1 división completa */}
      <section className="min-h-[80vh] relative flex items-end justify-center p-12 overflow-hidden">
        <video 
          autoPlay 
          muted 
          loop 
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={getVideoUrl("Cena romantica de la pagina de experiencias.mp4")} type="video/mp4" />
        </video>
        
        <div className="absolute inset-0 bg-black/40" />
        
        <div className="relative z-10 text-center max-w-2xl">
          <h2 className="font-sans text-4xl md:text-6xl font-light text-white mb-4">
            Cena Romántica
          </h2>
          <p className="font-sans text-xl text-gray-200">
            Momentos íntimos en el corazón de La Habana
          </p>
        </div>
      </section>

      {/* Sección 3: Noches Temáticas - 2 divisiones */}
      <section className="grid grid-cols-1 md:grid-cols-2 min-h-[70vh]">
        <div className="relative flex items-end justify-center p-8 overflow-hidden">
          <video 
            autoPlay 
            muted 
            loop 
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={getVideoUrl("Musica en vivo .mp4")} type="video/mp4" />
          </video>
          
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative z-10 text-center">
            <h3 className="font-sans text-3xl md:text-4xl font-light text-white mb-2">
              Música en Vivo
            </h3>
            <p className="font-sans text-base text-gray-200">Jazz, soul y ritmos que inspiran</p>
          </div>
        </div>
        <div className="relative flex items-end justify-center p-8 overflow-hidden">
          <video 
            autoPlay 
            muted 
            loop 
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={getVideoUrl("Eventos especiales-pagina de experiencias.mp4")} type="video/mp4" />
          </video>
          
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative z-10 text-center">
            <h3 className="font-sans text-3xl md:text-4xl font-light text-white mb-2">
              Eventos Especiales
            </h3>
            <p className="font-sans text-base text-gray-200">Noches únicas e inolvidables</p>
          </div>
        </div>
      </section>

      {/* Sección 4: Experiencias Gastronómicas - 3 divisiones */}
      <section className="grid grid-cols-1 md:grid-cols-3 min-h-[60vh]">
        <div className="relative flex items-end justify-center p-8 overflow-hidden">
          <video 
            autoPlay 
            muted 
            loop 
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={getVideoUrl("Platos signature seccion .mp4")} type="video/mp4" />
          </video>
          
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative z-10 text-center">
            <h3 className="font-sans text-2xl md:text-3xl font-light text-white mb-2">
              Platos Signature
            </h3>
            <p className="font-sans text-sm text-gray-200">Creaciones exclusivas del chef</p>
          </div>
        </div>
        <div className="relative flex items-end justify-center p-8 overflow-hidden">
          <video 
            autoPlay 
            muted 
            loop 
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={getVideoUrl("Entre amigos para la apgina de experiencia .mp4")} type="video/mp4" />
          </video>
          
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative z-10 text-center">
            <h3 className="font-sans text-2xl md:text-3xl font-light text-white mb-2">
              Entre Amigos
            </h3>
            <p className="font-sans text-sm text-gray-200">Conversaciones que alimentan el momento</p>
          </div>
        </div>
        <div className="relative flex items-end justify-center p-8 overflow-hidden">
          <video 
            autoPlay 
            muted 
            loop 
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={getVideoUrl("maridaje de ron y fuego para la pagina de experien.mp4")} type="video/mp4" />
          </video>
          
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative z-10 text-center">
            <h3 className="font-sans text-2xl md:text-3xl font-light text-white mb-2">
              Maridajes Perfectos
            </h3>
            <p className="font-sans text-sm text-gray-200">Rones cubanos</p>
          </div>
        </div>
      </section>

      {/* Sección 5: Celebración Grupal - 1 división completa */}
      <section className="min-h-[80vh] relative flex items-end justify-center p-12 overflow-hidden">
        <video 
          autoPlay 
          muted 
          loop 
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={getVideoUrl("Cenas de negocios.mp4")} type="video/mp4" />
        </video>
        
        <div className="absolute inset-0 bg-black/40" />
        
        <div className="relative z-10 text-center max-w-2xl">
          <h2 className="font-sans text-4xl md:text-6xl font-light text-white mb-4">
            Celebración Grupal
          </h2>
          <p className="font-sans text-xl text-gray-200">
            Espacios perfectos para compartir en grande
          </p>
        </div>
      </section>

      {/* Sección 6: Noche de Cocktails - 3 divisiones */}
      <section className="grid grid-cols-1 md:grid-cols-3 min-h-[60vh]">
        <div className="relative flex items-end justify-center p-8 overflow-hidden">
          <video 
            autoPlay 
            muted 
            loop 
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={getVideoUrl("Ambiente noctuno pagina de experiencias .mp4")} type="video/mp4" />
          </video>
          
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative z-10 text-center">
            <h3 className="font-sans text-2xl md:text-3xl font-light text-white mb-2">
              Ambiente Nocturno
            </h3>
            <p className="font-sans text-sm text-gray-200">La magia cuando cae la noche</p>
          </div>
        </div>
        <div className="relative flex items-end justify-center p-8 overflow-hidden">
          <video 
            autoPlay 
            muted 
            loop 
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={getVideoUrl("Blanco y Negro a color Viral.mp4")} type="video/mp4" />
          </video>
          
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative z-10 text-center">
            <h3 className="font-sans text-2xl md:text-3xl font-light text-white mb-2">
              Barra Premium
            </h3>
            <p className="font-sans text-sm text-gray-200">Los mejores destilados del mundo</p>
          </div>
        </div>
        <div className="relative flex items-end justify-center p-8 overflow-hidden">
          <video 
            autoPlay 
            muted 
            loop 
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src="https://customer-assets.emergentagent.com/job_adastra-resto-1/artifacts/sbr753mu_pagina%20de%20experiencia-muchahca%20vestido%20verde%20fumando%20tabaco.MOV" type="video/mp4" />
          </video>
          
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative z-10 text-center">
            <h3 className="font-sans text-2xl md:text-3xl font-light text-white mb-2">
              Experiencia Social
            </h3>
            <p className="font-sans text-sm text-gray-200">Conecta y disfruta</p>
          </div>
        </div>
      </section>

      {/* Call to Action Final */}
      <section className="relative py-20 overflow-hidden bg-black">
        <div className="relative z-10 container-custom text-center">
          <div className="max-w-4xl mx-auto">
            <div className="inline-flex items-center space-x-2 bg-green-600/20 backdrop-blur-sm px-4 py-2 md:px-6 md:py-3 rounded-full border border-green-400/30 mb-6 md:mb-8">
              <FontAwesomeIcon icon={faStar} className="w-4 h-4 md:w-5 md:h-5 text-green-400" />
              <span className="text-green-400 font-medium text-sm md:text-base">¿Listo para vivir la experiencia?</span>
            </div>

            <h2 className="font-sans text-4xl md:text-5xl font-light text-white mb-6">
              Reserva tu <span className="font-normal italic text-green-400">Experiencia</span>
            </h2>

            <p className="font-sans text-lg text-gray-200 mb-8 max-w-2xl mx-auto">
              Cada momento en ADASTRA es único. No dejes que se escape tu próxima experiencia inolvidable.
            </p>

            <div className="flex justify-center">
              <Link 
                to="/reservas"
                className="border border-white text-white px-8 py-3 font-bold tracking-wide hover:bg-white hover:text-black transition-all duration-300 inline-flex items-center justify-center w-auto"
              >
                <span>RESERVAR MESA</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      
    </div>
  );
};

export default Experiencias;